<template>
  <div id="MainData">
    <vx-card class="shadow-sm" :title="$t('OwnerDetails')">
      
      <!-- 1. البيانات الأساسية -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary flex items-center">
            <feather-icon icon="UserIcon" svgClasses="w-5 h-5 mr-2 rtl:ml-2" />
            {{ $t('BasicInformation') }}
          </h6>
        </div>
        
        <!-- كود المالك (يعرض في التعديل فقط) -->
        <div class="vx-col md:w-1/4 w-full mb-4" v-if="PropertyOwner.Id && PropertyOwner.Id > 0">
          <label class="text-sm opacity-75">{{ $t('OwnerCode') }}</label>
          <vs-input v-model="PropertyOwner.OwnerCode" class="w-full mt-1" disabled />
        </div>
        
        <!-- الاسم بالعربي -->
        <div :class="[PropertyOwner.Id > 0 ? 'md:w-1/3' : 'md:w-1/2', 'w-full mb-4']">
          <label class="text-sm opacity-75">{{ $t('FullNameAr') }} <span class="text-danger">*</span></label>
          <vs-input v-model="PropertyOwner.FullNameAr" class="w-full mt-1" name="FullNameAr" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('FullNameAr')">{{ errors.first('FullNameAr') }}</span>
        </div>

        <!-- الاسم بالإنجليزي -->
        <div :class="[PropertyOwner.Id > 0 ? 'md:w-1/3' : 'md:w-1/2', 'w-full mb-4']">
          <label class="text-sm opacity-75">{{ $t('FullNameEn') }}</label>
          <vs-input v-model="PropertyOwner.FullNameEn" class="w-full mt-1" name="FullNameEn" />
        </div>
      </div>

      <vs-divider />

      <!-- 2. بيانات التواصل والحساب ERP -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary flex items-center">
            <feather-icon icon="PhoneIcon" svgClasses="w-5 h-5 mr-2 rtl:ml-2" />
            {{ $t('ContactAndAccountInfo') }}
          </h6>
        </div>

        <!-- رقم الهاتف -->
        <div class="vx-col md:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('PhoneNumber') }} <span class="text-danger">*</span></label>
          <vs-input v-model="PropertyOwner.PhoneNumber" class="w-full mt-1" name="PhoneNumber" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('PhoneNumber')">{{ errors.first('PhoneNumber') }}</span>
        </div>

        <!-- البريد الإلكتروني -->
        <div class="vx-col md:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('Email') }}</label>
          <vs-input type="email" v-model="PropertyOwner.Email" class="w-full mt-1" name="Email" v-validate="'email'" />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
        </div>

        <!-- رقم حساب الـ ERP -->
        <!-- <div class="vx-col md:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('ErpAccountId') }}</label>
          <vs-input type="number" v-model="PropertyOwner.ErpAccountId" class="w-full mt-1" name="ErpAccountId" />
        </div> -->
      </div>

      <vs-divider />

      <!-- 3. تفاصيل الهوية والحالة -->
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary flex items-center">
            <feather-icon icon="CreditCardIcon" svgClasses="w-5 h-5 mr-2 rtl:ml-2" />
            {{ $t('IdentityAndStatus') }}
          </h6>
        </div>

        <!-- الجنسية -->
        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("Nationality") }}</label>
          <v-select 
            class="mt-1"
            :options="Nationalities" 
            :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'" 
            v-model="PropertyOwner.NationalityId" 
            :reduce="n => n.Id" 
          />
        </div>

        <!-- الهوية / الإقامة -->
        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('NationalID_Iqama') }} <span class="text-danger">*</span></label>
          <vs-input v-model="PropertyOwner.NationalIdOrIqama" class="w-full mt-1" name="NationalIdOrIqama" v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('NationalIdOrIqama')">{{ errors.first('NationalIdOrIqama') }}</span>
        </div>

        <!-- نوع الهوية -->
        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('ID_Type') }}</label>
          <vs-select v-model="PropertyOwner.NationalIDType" class="w-full mt-1">
            <vs-select-item :value="1" :text="$t('NationalID')" />
            <vs-select-item :value="2" :text="$t('Iqama')" />
            <vs-select-item :value="3" :text="$t('Passport')" />
          </vs-select>
        </div>

        <!-- حالة التفعيل IsActive -->
        <div class="vx-col md:w-1/4 w-full mb-4 flex flex-col justify-center">
          <label class="text-sm opacity-75 mb-2">{{ $t('Status') }}</label>
          <div class="flex items-center">
            <vs-switch v-model="PropertyOwner.IsActive" color="success">
              <span slot="on">{{ $t('Active') }}</span>
              <span slot="off">{{ $t('Inactive') }}</span>
            </vs-switch>
            <span class="ml-2 rtl:mr-2 font-medium">
              {{ PropertyOwner.IsActive ? $t('Active') : $t('Inactive') }}
            </span>
          </div>
        </div>
      </div>

    </vx-card>
    

    <!-- الأزرار -->
    <div class="flex flex-wrap items-center justify-end mt-6">
      <vs-button type="border" color="rgba(0,0,0,0.5)" icon-pack="feather" icon="icon-x" @click="$router.back()" class="mr-4 rtl:ml-4 rtl:mr-0">
        {{ $t("Cancel") }}
      </vs-button>
      <vs-button icon-pack="feather" icon="icon-save" @click="submitData">
        {{ $t("SaveChanges") }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import vSelect from "vue-select";
import modulePropertyOwners from "@/store/PropertyOwners/modulePropertyOwners.js";
import moduleNationalities from "@/store/Nationality/moduleNationalities.js";

export default {
  name: "MainData",
  components: { VxCard, vSelect },
  props: {
    PropertyOwner: {
      type: Object,
      default: () => ({
        Id: 0,
        FullNameAr: "",
        FullNameEn: "",
        PhoneNumber: "",
        Email: "",
        ErpAccountId: null,
        NationalIdOrIqama: "",
        NationalIDType: 1,
        NationalityId: null,
        IsActive: true
      })
    }
  },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    Nationalities() { return this.$store.state.NationalitiesList.Nationalities || []; }
  },
  methods: {
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const isUpdate = this.PropertyOwner.Id && this.PropertyOwner.Id > 0;
          const actionName = isUpdate 
            ? "PropertyOwnersList/updateItem" 
            : "PropertyOwnersList/addItem";

          this.$vs.loading();
          this.$store.dispatch(actionName, this.PropertyOwner)
            .then(() => {
              this.$vs.loading.close();     
              this.showSuccess();
              return this.$store.dispatch("PropertyOwnersList/fetchDataListItems");
            })
            .then(() => { 
              this.$router.push("/PropertyOwners"); 
            })
            .catch((err) => {
              this.$vs.loading.close();

              const errorMessage = (err.response && err.response.data && err.response.data.message) 
                ? err.response.data.message 
                : this.$t("ErrorOccurred");

              this.$vs.notify({
                title: this.$t("Error"),
                text: errorMessage,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            });
        }
      });
    },
    showSuccess() {
      this.$vs.notify({ title: this.$t("Success"), text: this.$t("SavedSuccessfully"), color: "success" });
    }
  },
  created() {
    if (!modulePropertyOwners.isRegistered) {
      this.$store.registerModule("PropertyOwnersList", modulePropertyOwners);
      modulePropertyOwners.isRegistered = true;
    }
    if (!moduleNationalities.isRegistered) {
      this.$store.registerModule("NationalitiesList", moduleNationalities);
      moduleNationalities.isRegistered = true;
    }
    this.$store.dispatch("NationalitiesList/fetchDataListItems");
  }
};
</script>